import { createContext } from 'react';
import { SnackbarContextType } from '../types/snackbar-context.type';

export const SnackbarContext = createContext<SnackbarContextType>({
    snackbarContext: { open: false },
    setSnackbarContext: () => {},
});
